module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.a5f411e0.mp3";